<template>
  <div class="point-of-pain flex-box">
    <div class="point-of-pain-title" v-if="title">{{ title }}</div>
    <div class="point-of-pain-description" v-if="description">{{ description }}</div>
    <div class="point-of-pain-triangle-wrap" v-if="isTriangle">
      <div class="point-of-pain-triangle">
        <div v-if="triangleContent">{{ triangleContent }}</div>
      </div>
    </div>
    <div class="container">
      <div class="content-box">
        <div class="list-item" :class="{'isThree': isThree}" v-for="(item, k) in listData" :key="k">
          <div class="item-num">{{ item.num }}</div>
          <div class="item-title">{{ item.title }}</div>
          <div class="item-description">{{ item.description }}</div>

          <div class="cl-list">
            <div class="cl-list-item"  v-for="(subItem, sk) in item.contentList" :key="sk">
              <div class="cl-l-i-title" v-if="subItem.title">{{ subItem.title }}：</div>
              <div class="cl-l-i-content">{{ subItem.content }}</div>
            </div>
          </div>
          <div class="item-hover-mark"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    triangleContent: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    listData: {
      type: Array,
      default: () => {
        return []
      }
    },
    isTriangle: {
      type: Boolean,
      default: false
    },
    isThree: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.point-of-pain {
  flex-direction: column;
  align-items: center;
  background-color: #f0f2f5;

  .point-of-pain-title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    line-height: 4rem;
    padding: 9rem 0 2.4rem;
  }

  .point-of-pain-description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    padding-bottom: 7.6rem;
  }

  .point-of-pain-triangle-wrap {
    width: 100%;
    background: radial-gradient(0% 117% at 41% 0%, #FBFDFF 0%, #EAF4FF 100%);
    position: relative;
    .point-of-pain-triangle {
      width: 30rem;
      margin: auto;
      border-top: 10rem solid silver;
      border-bottom: 0rem solid transparent;
      border-left: 40rem solid transparent;
      border-right: 40rem solid transparent;
      div {
        position: absolute;
        left: 50%;
        top: 45%;
        font-size: 3rem;
        transform: translate(-50%, -50%);
      }
    }
  } 

  

  .container {
    width: 100%;
    display: flex;
    background: radial-gradient( 0% 117% at 41% 0%, #FBFDFF 0%, #EAF4FF 100%);
    justify-content: center;
  }

  .content-box {
    position: relative;
    width: calc(192rem - 50rem);
    margin: 4rem auto 8rem;
    overflow: hidden;

    .list-item {
      float: left;
      width: 68rem;
      height: 28rem;
      background: #FFFFFF;
      box-shadow: 0rem 0.5rem 4rem 0rem rgba(196,211,228,0.3);
      padding: 5.6rem 4.8rem 0;
      margin: 4rem 3rem 0 1rem;
      cursor: pointer;
      position: relative;
      &:nth-child(2n) {
        margin-right: 0;
      }
      .item-num {
        position: absolute;
        left: 4.8rem;
        top: 1.6rem;
        opacity: .1;
        height: 7rem;
        font-family: DINAlternate, DINAlternate;
        font-weight: bold;
        font-size: 6rem;
        color: #3674FE;
        line-height: 7rem;
        text-align: left;
        font-style: normal;
      }
      .item-title {
        margin-bottom: 3rem;
        height: 2.8rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 2.8rem;
        color: #333333;
        line-height: 2.8rem;
        text-align: left;
        font-style: normal;
      }
      .cl-list {
        margin-top: 4.1rem;
        .cl-list-item {
          .cl-l-i-content {
            padding-left: 3rem;
            position: relative;
            font-weight: 400;
            font-size: 1.8rem;
            color: #333333;
            line-height: 3.2rem;
            text-align: left;
            font-style: normal;
            &::before {
              position: absolute;
              left: 0;
              top: .9rem;
              content: '';
              width: 1rem;
              height: 1rem;
              border: 0.2rem solid #3674FE;
              display: inline-block;
              border-radius: 50%;
              margin-right: 1.2rem;
            }
          }
        }
      }
      .item-hover-mark {
        position: absolute;
        right: 0.8rem;
        bottom: 0.8rem;
      }
      &:hover {
        .item-hover-mark {
          width: 0;
          height: 0;
          border-width: 4.2rem; /* 设置边长 */
          border-style: solid;
          border-color: transparent #65AAFF #65AAFF transparent; /* 上、右、下为透明色，左为指定的颜色（这里为黑色）*/
        }
      }
    }

    .isThree {
      width: 44rem;
      height: 50rem;
      margin: 0;
      &:nth-child(3n + 2) {
        margin: 0 5rem;
      }
    }

  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .point-of-pain {
    .point-of-pain-title {
      width: 100%;
      font-size: 2.4rem !important;
      line-height: 3.2rem !important;
      padding-left: 1.6rem;
      padding-right: 1.6rem;
      text-align: center;
      white-space: normal;
      word-break: break-word;
    }
    .point-of-pain-description {
      width: 100%;
      font-size: 1.4rem !important;
      line-height: 2.2rem !important;
      padding: 0 1.6rem;
      text-align: center;
      white-space: normal;
      word-break: break-word;
    }
    .point-of-pain-triangle-wrap {
      overflow: visible;
      padding: 0 1.6rem;
      display: flex;
      justify-content: center;
      z-index: 1;
    }
    .point-of-pain-triangle-wrap .point-of-pain-triangle {
      width: min(28rem, 100%);
      height: 7.2rem;
      margin: 0 auto;
      border: 0 !important;
      background: transparent !important;
      position: relative;
      box-sizing: border-box;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding-top: 1.2rem;
      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: silver;
        clip-path: polygon(0 0, 100% 0, 50% 100%);
        z-index: 0;
      }
      div {
        position: relative !important;
        left: auto !important;
        top: auto !important;
        transform: none !important;
        z-index: 1;
        font-size: 2rem !important;
        line-height: 2.8rem;
        white-space: nowrap;
      }
    }
    .content-box {
      width: 100%;
      padding: 0 1.6rem;
      overflow: visible;
      .list-item,
      .isThree,
      .list-item:nth-child(2n),
      .isThree:nth-child(3n + 2) {
        float: none !important;
        width: 100% !important;
        height: auto !important;
        margin: 0 0 1.6rem !important;
        padding: 2.4rem 1.6rem 3.2rem !important;
        overflow: visible;
      }
      .item-title {
        height: auto;
        line-height: 3.2rem;
        white-space: normal;
        word-break: break-word;
      }
      .cl-l-i-content {
        white-space: normal;
        word-break: break-word;
      }
    }
  }
}
</style>
